/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import AudiosService from "../Services/Audios";
import AuthorsService from "../Services/Authors";
import WithoutLyrics from "../Images/audiolyrics.svg";
import WithLyrics from "../Images/audiowithoutlyrics.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Reset from "../Images/reset.png";
import ListPagination from "../Components/ListPagination";
import "../Styles/Audios.css";
import "../Styles/Sidebar.css";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import $ from "jquery";
import imgpause from "../assets/audioPlayer/img/yellowplay.svg";
import { useUser } from "../Contexts/UserContext";
import imgdownload from "../Images/downloadpravachan.svg";
import Headphone from "../assets/img/headp.png";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { LogInModel } from "./LoginModel";
import { SideBar } from "./SubMenu";
import Loader from "./Loader";
import { FilterIcon, HeadPhoneIcon, HeadPhoneIcon2 ,SortIcon} from "./Icon";
import HeadPhone from "../assets/img/headpho.png"


const AudiosPage = () => {
  const { isSelected } = useUser();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [audios, setAudios] = useState<any[] | undefined>(undefined);
  const [hoveredSinger, setHoveredSinger] = useState<any>(null);


  const [hoveredCategoryId, setHoveredCategoryId] = useState<any>(null);
  const [hoveredLyricsId, setHoveredLyricsId] = useState<any>(null);

  const [refresh, setRefresh] = useState(false);

  const [SortValue, setSortValue] = useState("3");

  const [categories, setCategories] = useState<any[]>([]);
  const [CategoryId, setCategoryId] = useState("");
  const [Lyrics, setLyrics] = useState<any>("");
  const [LyricsId, setLyricsId] = useState<any>("");
  const [Singer, setSinger] = useState<any>("");
  const [SingerId, setSingerId] = useState<any>("");

  const [activeIndex, setActiveIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleItemClick = (index: any) => {
    setActiveIndex(index);
  };

  var timestamp = new Date().getTime();
  const encoded = btoa(timestamp.toString());

  const [pagination, setPagination] = useState({
    pageNo: 0,
    recordsPerPage: 12,
    totalRecords: 0,
  });

  const [logIn, setLogIn] = useState<boolean>(false);
  const [clickedAudio, setClickedAudio] = useState<{ audio: any, index: number } | null>(null);

  const closeModal = () => {
    setLogIn(false);
    setClickedAudio(null);
  };
  const UserIdentity = localStorage.getItem("Token") as any;
  const location = useLocation();

  const [loginState, setLoginState] = useState<boolean>(false);

  const handleLoginStateChange = async (newState: any) => {
    setLoading(true); // Show loader

    setLoginState(newState === true);
    localStorage.setItem("type", "audios");

    // Navigate only to the specific audio that was clicked
    if (newState === true && clickedAudio) {
      const { audio, index } = clickedAudio;
      navigate(`/audios/${audio.slug}`, {
        state: {
          audioId: audio.id,
          audioslug: audio.slug,
          sorting: SortValue,
          pageNum: pagination.pageNo,
          index: index,
          audiocat: CategoryId,
          audioAuthor: state?.authorId || SingerId
        },
      });
    }

    setLoading(false); // Hide loader after navigation
  };

  const state = location.state as {
    authorId: string;
    authorName: string;
    type: string;
    audiocat: string;
    audioAuthor: string;
  };

  const catId: any = localStorage.getItem("categoryId") || CategoryId || state?.audiocat;
  const autId: any = localStorage.getItem("authorId") || SingerId || state?.authorId;
  const sort: any = localStorage.getItem("sort") || SortValue;

  const [bread, showBread] = useState<string>("");
  const [disableChildColored, setDisableChildColored] = useState(false);
  const [resetClicked, setResetClicked] = useState(false);
  const [isSelecteditem, setIsSelecteditem] = useState<boolean>(false);

  function ResetData() {
    setDisableChildColored(false);
    setCategoryId("");
    setSingerId("");
    setLyricsId("");
    setSortValue("3");
    setActiveIndex(null);
    localStorage.removeItem("categoryId");
    localStorage.removeItem("authorId");
    localStorage.removeItem("sort");
    setPagination({
      ...pagination,
      pageNo: 0,
    });
    setResetClicked(true); // Trigger reset (this will remove highlighted item color)
    setTimeout(() => setResetClicked(false), 50);
    setRefresh(true);
    // window?.location?.reload();
  }

  function ClickOnFilter(
    SingerId: string,
    CategoryId: string,
    LyricsId: number
  ) {
    setRefresh(false);
    AudiosService.getAudios(
      0,
      pagination.recordsPerPage,
      false,
      CategoryId || state?.audiocat || catId,
      SingerId || state?.authorId || autId,
      "",
      SortValue || sort,
      "",
      window.location.pathname === "/audios/special" ? true : false,
      state?.type || "audios",
      LyricsId,
      "",
      ""
    ).then((res) => {
      if (res) {
        setAudios(res.result?.items);
        setPagination({
          ...pagination,
          pageNo: 1,
          totalRecords: res.result?.totalRecords,
        });
      }
    });
  }

  const downloadAudio = (audioPath: any) => {
    const imageUrl = audioPath;
    const link = document.createElement('a');
    link.href = imageUrl; link.download = 'image.jpg';
    document.body.appendChild(link); link.click();
    document.body.removeChild(link);
  };

  // useEffect(() => {
  //   ClickOnFilter(SingerId, CategoryId, LyricsId);
  //   $(".CategoryList > ul > li > div").removeClass("listActive");
  //   $("#cat-" + CategoryId).addClass("listActive");

  //   // $(".Authorlist > ul > li > div").removeClass("listActive");
  //   // $("#sin-" + SingerId).addClass("listActive");
  //   if (LyricsId === "") {
  //     $(".LanguageList > ul > li > div").removeClass("listActive");
  //     $("#lan-" + 0).addClass("listActive");
  //   }
  //   if (LyricsId === "lyrics0") {
  //     $(".LanguageList > ul > li > div").removeClass("listActive");
  //     $("#lan-" + 1).addClass("listActive");
  //   }
  // }, [SingerId, CategoryId, LyricsId]);

  useEffect(() => {
  ClickOnFilter(SingerId, CategoryId, LyricsId);
}, [SingerId, CategoryId, LyricsId]);
  useEffect(() => {
    AudiosService.getFilters("audio").then((res) => {
      if (res.status) {
        setSinger(res.result.authors);
        setLyrics(res.result);
      }
    });
  }, [i18n.language]);

  useEffect(() => {
    AudiosService.getAudioCategories().then((res) => {
      if (res.status) {
        setCategories(res.result);
      }
    });
  }, [i18n.language]);

  useEffect(() => {
    ResetData();
  }, [isSelected]);

  useEffect(() => {
    setRefresh(false);
    const fetchData = async () => {
      try {
        const response = await AudiosService.getAudios(
          pagination.pageNo === 0
            ? 0
            : pagination.recordsPerPage * pagination.pageNo - 12,
          pagination.recordsPerPage,
          false,
          catId,
          autId,
          "",
          sort,
          "",
          window.location.pathname === "/audios/special" ? true : false,
          state?.type || "audios",
          LyricsId,
          "",
          ""
        )
        const res = await response;
        setAudios(res.result?.items);
        setPagination({
          ...pagination,
          totalRecords: res.result?.totalRecords,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Hide loader after fetching
      }
    }
    fetchData();
  }, [refresh, SortValue, i18n.language, CategoryId, SingerId, loginState]);

  // Play/open does not require login; download/favourite still gate on Token elsewhere
  const handleAudioClick = (audio: any, i: number) => {
    console.log("naviage-from-audio-page", state);

    localStorage.setItem("type", "audios");
    navigate(`/audios/${audio?.slug}`, {
      state: {
        audioId: audio.id,
        audioslug: audio.slug,
        sorting: SortValue,
        pageNum: pagination.pageNo,
        index: i,
        audiocat: CategoryId,
        audioAuthor: state?.authorId || SingerId,
      },
    });
  };

  useEffect(() => {
    AuthorsService.GetAuthorDataById(state?.authorId).then((res) => {
      showBread(res?.result?.name);
    });
  }, [i18n.language, refresh]);

  useEffect(() => {
    if (CategoryId !== "") {
      setSortValue("0")
    }
  }, [CategoryId])

  useEffect(() => {
  }, [localStorage.getItem("Token"), UserIdentity])

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      pageNo: 1   // 👈 reset to first page
    }));
    setRefresh(true); // 👈 trigger fresh API call
  }, [CategoryId, SingerId, LyricsId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  

 const authorTitle =
  state?.authorName === "श्रद्धेय श्रीजयदयालजी गोयन्दका"
    ? t("Jayadayal_Ji_audio_title")
    : state?.authorName === "श्रद्धेय श्रीहनुमानप्रसादजी पोद्दार"
    ? t("HanumanPrasad_Ji_audio_title")
    : state?.authorName === "श्रद्धेय स्वामी श्रीरामसुखदासजी महाराज"
    ? t("Ramsukhdas_Ji_audio_title")
    : t("Audio_title_tr");

const authorDescription =
  state?.authorName === "श्रद्धेय श्रीजयदयालजी गोयन्दका"
    ? t("Jayadayal_Ji_audio_description")
    : state?.authorName === "श्रद्धेय श्रीहनुमानप्रसादजी पोद्दार"
    ? t("HanumanPrasad_Ji_audio_description")
    : state?.authorName === "श्रद्धेय स्वामी श्रीरामसुखदासजी महाराज"
    ? t("Ramsukhdas_Ji_audio_description")
    : t("Audio_description_tr");



  return (
    <>
   <div style={{ backgroundColor: "rgb(255, 237, 188)", padding: "0px 0px 0px 0px",marginTop:"-60px" }}>
      <div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto", padding: "0 10px",backgroundColor:"rgb(255, 237, 188)" }}>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: "20px",
                flexWrap: "wrap",
                padding: "28px 0 16px",
              }}
            >
              <div style={{ flex: "0 1 260px", minWidth: "220px" }}>
                <div style={{ padding: "8px 0" }}>
                  <h2 style={{ color: "#cf2c24", fontSize: "40px", margin: 0, fontWeight: 700,marginTop:"70px", textShadow: "0px 0px 4px rgba(255,255,255,0.9)" }}>
                    {t("Audios_tr")}
                  </h2>
                  <div style={{ marginTop: "10px", fontSize: 19,fontWeight:600,color:"rgb(45, 42, 41)" }}>
                    <Link to="/" style={{ marginRight: "", color: "#2d2a29" }}>{t("Home_tr")}</Link>
                    <span style={{ margin: "0 6px" }}>/</span>
                    <span>{t("Audios_tr")}</span>
                  </div>
                </div>
              </div>

              <div
                style={{
                  width: "1px",
                  minHeight: "100px",
                  background: "#facc6f",
                  marginTop: "65px",
                }}
              />

              <div style={{ flex: "1 1 520px", minWidth: "300px" }}>
                <h1
                  style={{
                    textAlign: "center",
                    color: "rgb(228, 121, 7)",
                    textShadow: "0px 0px 4px rgba(255,255,255,0.9)",
                    fontWeight: 600,
                    margin: 0,
                    paddingTop:"30px",
                    // marginb:"-10px",
                    fontSize:"32px"
                  }}
                >
                  {/* {t("Audio_title_tr")} */}
                  {authorTitle}
                </h1>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "8px",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                  <svg
                    width="26"
                    height="18"
                    viewBox="0 0 26 18"
                    style={{ margin: "0 12px" }}
                  >
                    <rect x="1" y="7" width="2" height="4" rx="1" fill="#E5B15A" />
                    <rect x="5" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                    <rect x="9" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                    <rect x="13" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                    <rect x="17" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                    <rect x="21" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                  </svg>
                  <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                </div>

                <p
                  style={{
                    fontSize: 17,
                    color: "#4a4036",
                    textShadow: "0px 0px 4px rgba(255,255,255,0.8)",
                    // margin: "25px 0 -10px",
                    margin:"18px 0px 0px 0px",
                    width: "100%",
                    lineHeight: 1.75,
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                    textAlign: "justify",
                  }}
                >
                  {/* {t("Audio_description_tr")} */}
                  {authorDescription}
                </p>
              </div>
            </div>
      </div>
  </div>

      <div className="fontfamily audios-page-container">
        
        <div className="containers">
          <div className="gst-page-content ">
            <div className="row">
              <div className="col-lg-3">
                <div className="sidebar-container">
                  <div>
                    <div className="cardbackground filter-header">
                     <FilterIcon/> <span className="boxheadtitle" style={{color:"rgb(228, 121, 7)"}}>{t("Filter_tr")}</span> 
                      {(SingerId !== "" || CategoryId !== "" || LyricsId !== "" || pagination.pageNo > 1) && (
                        <img
                          alt="reset"
                          src={Reset}
                          className="resetimg"
                          onClick={() => {
                            // window?.location?.reload();
                            setIsSelecteditem(false);
                            ResetData();
                          }}
                        />
                      )}
                    </div>

                    <div className="filter-options-container">
                      {/* audio list */}
                      <Accordion
                        defaultExpanded
                        elevation={0}
                        className="filter-accordion"
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          className="filter-accordion-summary"
                          style={{
                            background: "#fffaec",
                            height: "0px",
                            minHeight: "25px",
                            marginTop: "15px"
                          }}
                        >
                          {/* <h2 className="filtertitle audio-list-title">
                            {t("audioList_tr")}
                          </h2> */}

                            <p className="filtertitle audio-list-title" style={{fontSize:"20px",paddingTop:10}}>{t("audioList_tr")}</p>
                        </AccordionSummary>

                        <AccordionDetails className="filter-accordion-details">
                          <div>
                            <SideBar
                              setIsSelecteditem={setIsSelecteditem}
                              isSelectedItem={isSelecteditem}
                              items={categories!}
                              onClick={(value: any) => {
                                if (value) {
                                  if (value.items === null)
                                    setCategoryId(value.id);
                                }
                              }}
                              disableChildColored={false}
                            // onRefresh={ResetData}
                            />
                          </div>
                        </AccordionDetails>
                      </Accordion>
                      {/* Preacher  */}
                      <Accordion
                        elevation={0}
                        className={`filter-accordion ${state?.authorId ? "hidden-accordion" : ""
                          }`}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          className="filter-accordion-summary preacher-summary"
                          style={{ background: "#fffaec" }}
                        >
                          {/* <h2 className="filtertitle">{t("Singer_tr")}</h2> */}
                            <p className="filtertitle" style={{fontSize:"20px",paddingTop:10}}>{t("Singer_tr")}</p>
                        </AccordionSummary>
                        <AccordionDetails className="filter-accordion-details preacher-details">
                          {/* {Singer && Singer.length > 0
                            ? Singer?.map((Singer: any) => (
                              <div
                                key={`c-${Singer.id}`}
                                className="Authorlist"
                                onClick={() => {
                                  setSingerId(Singer.id);
                                }}
                              >
                                <ul className="author-list-ul">
                                  <li>
                                    <div
                                      id={`sin-${Singer.id}`}
                                      className="author-name"
                                    >
                                      {Singer.name}
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            ))
                            : ""} */}

                            {Singer && Singer.length > 0
                ? Singer?.map((Singer: any) => (
                    <div
                      key={`c-${Singer.id}`}
                      className="Authorlist"
                      onClick={() => {
                        setSingerId(Singer.id);
                      }}
                      onMouseEnter={() => setHoveredSinger(Singer.id)}
                      onMouseLeave={() => setHoveredSinger(null)}
                    >
                      <ul className="author-list-ul">
                        <li>
                          <h2
                            style={{
                              fontSize: "21px",
                              cursor: "pointer",
                              fontWeight: SingerId === Singer.id ? 600 : 400,
                              color:
                                SingerId === Singer.id ||
                                hoveredSinger === Singer.id
                                  ? "#cf2c24"
                                  : "#545454",
                              fontFamily: "ChanakyaUni",
                              transition: "0.3s",
                            }}
                          >
                            {Singer.name}
                          </h2>
                        </li>
                      </ul>
                    </div>
                  ))
                : ""}
                        </AccordionDetails>
                      </Accordion>
                      {/* lyrics & without lyrics */}
                      <Accordion elevation={0} className="filter-accordion">
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          className="filter-accordion-summary lyrics-summary"
                          style={{ background: "#fffaec" }}
                        >
                          {/* <h2 className="filtertitle">{t("Lyrics_tr")}</h2> */}
                            <p className="filtertitle" style={{fontSize:"20px",paddingTop:10}}>{t("Lyrics_tr")}</p>
                        </AccordionSummary>

                        <AccordionDetails className="filter-accordion-details lyrics-details">
                          <div className="">
                            <div className="LyricsList">
                              <ul className="lyrics-type-list">
                                <li
                                  key={1}
                                  onClick={() => {
                                    handleItemClick(1);
                                    setLyricsId(1);
                                  }}
                                >
                                  <div
                                    className={`lyrics-option ${activeIndex === 1 ? "active-lyrics" : ""
                                      }`}

                                      onMouseEnter={() => setHoveredLyricsId(1)}
                                      onMouseLeave={() => setHoveredLyricsId(null)}
                                      style={{
                                        color:
                                          activeIndex === 1 || hoveredLyricsId === 1
                                            ? "#cf2c24"
                                            : "#545454",
                                        fontWeight:
                                          activeIndex === 1 ? 600 : 400,
                                        cursor: "pointer",
                                        transition: "0.3s",
                                      }}
                                  >
                                    {t("Lyrics_tr")}
                                  </div>
                                </li>
                                <li
                                  key={2}
                                  onClick={() => {
                                    handleItemClick(2);
                                    setLyricsId(2);
                                  }}
                                >
                                  <div
                                    className={`lyrics-option ${activeIndex === 2 ? "active-lyrics" : ""
                                      }`}

                                        onMouseEnter={() => setHoveredLyricsId(2)}
                                  onMouseLeave={() => setHoveredLyricsId(null)}
                                  style={{
                                    color:
                                      activeIndex === 2 || hoveredLyricsId === 2
                                        ? "#cf2c24"
                                        : "#545454",
                                    fontWeight:
                                      activeIndex === 2 ? 600 : 400,
                                    cursor: "pointer",
                                    transition: "0.3s",
                                  }}
                                  >
                                    {t("Without_Lyrics_tr")}
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </div>
                </div>
              </div>

              
              <div className="col-lg-9">
                <div className="detailbg audios-list-container">
                  <div className="sidebarmargin">
                    <div className="align-items-center row" style={{marginTop:"-18px"}}>
                      <div className="col-6" >
                        <div className="filter1 total-records-container">
                          
                          <span className="total-records-text" >
                             {/* <HeadPhoneIcon />  */}
                             <span style={{ color:"rgb(228, 121, 7)",fontFamily:"chanakyaUni",fontSize:"22px"}}> {t("Total_Records_tr")} </span>: {pagination.totalRecords}
                          </span>
                        </div>
                      </div>
                      <div className="filter1 col-6 sort-container">
                        <div className="filter1 sort-options" style={{cursor:"pointer"}}>
                         <SortIcon/><span style={{color:"rgb(228, 121, 7)",fontFamily:"chanakyaUni",fontSize:"22px"}}>{t("Sort_tr")}</span>
                          <select
                            value={SortValue}
                            onChange={(e) => {
                              setSortValue(e.target.value);
                            }}
                            className="sort-select"
                          >
                            <option value="0">{t("General_tr")}</option>
                            <option value="3">{t("Popular_tr")}</option>
                            <option value="2">{t("Latest_tr")}</option>
                            <option value="1">{t("Title_tr")}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  {audios && audios.length > 0 ? (
                    <div>
                      {audios.map((audio, i) => (
                        <div key={`audio-${audio.id}`}>
                          <div className="sidebarmargin">
                            <div
                              className="audiosBox"
                              onClick={() => handleAudioClick(audio, i)}
                            >
                              {/* ICON */}
                              <div className="audio-item-icon">
                                <img
                                  className="audioicon"
                                  src={
                                    audio.lyricsHash != null && audio.lyricsHash !== ""
                                      ? WithLyrics
                                      : WithoutLyrics
                                  }
                                  onError={(e) => {
                                    e.currentTarget.src = WithoutLyrics;
                                  }}
                                  alt={audio.name}
                                  title={audio.name}
                                />
                              </div>

                              {/* TEXT */}
                              <div className="audio-item-text">
                                <h3 className="audio-item-title">
                                  {audio.name != null &&
                                    audio.name.length > 100
                                    ? audio.name.slice(0, 80) + "..."
                                    : audio.name}
                                </h3>
                                {audio.description && (
                                  <label className="audio-item-description">
                                    {audio.description}
                                  </label>
                                )}
                                {audio.author && (
                                  <label className="audio-item-author">
                                    {audio.author}
                                  </label>
                                )}
                                <label className="audio-item-length">
                                  {audio.audioLength}
                                </label>
                              </div>

                              {/* BUTTONS */}
                              <div className="btns">
                                <div className="buttonres">
                                  <a
                                    id="download"
                                    title="Download"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (localStorage.getItem("Token")) {
                                        downloadAudio(
                                          audio.audioPath != null
                                            ? audio.audioPath +
                                            "?t=" +
                                            encoded +
                                            "&download_attachment=true"
                                            : "no record found"
                                        );
                                      } else {
                                        setLogIn(true);
                                      }
                                    }}
                                  >
                                    <img
                                      alt="download"
                                      src={imgdownload}
                                      className="downloadbtn"
                                    />
                                  </a>
                                </div>

                                <div className="audio-play-button-container">
                                  <img
                                    alt="Play"
                                    title="Play"
                                    src={imgpause}
                                    className="playbtn"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      <div
                        className={`col-12 pagination-container ${pagination.totalRecords <= 12 ? "hidden-pagination" : ""
                          }`}
                      >
                        <ListPagination
                          totalRecords={pagination.totalRecords}
                          recordsPerPage={pagination.recordsPerPage}
                          currentPage={pagination.pageNo}
                          onClick={(p) => {
                            setPagination({
                              ...pagination,
                              pageNo: p,
                            });
                            setRefresh(true);
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="ebooks-category resultnotfound">
                      {audios?.length === 0 ? (
                        <label>{t("result_not_found_tr")}</label>
                      ) : (
                        <div>
                          {loading && <Loader loading={loading} />}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>




              
            </div>
          </div>
        </div>
      </div >
      <LogInModel opens={logIn} onCloses={closeModal} onLoginStateChange={handleLoginStateChange} />
    </>
  );
};
export default AudiosPage;
